// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import TermsOfServicePage from "../pages/TermsOfService/TermsOfService";
const __wvcRoutePaths = ["/TermsOfServicePage", "/terms-of-service"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["home", "homepage", "post", "privacy-policy", "privacypolicypage", "start-my-exit-plan", "startmyexitplanpage", "terms-conditions", "terms-of-service", "termsconditionspage", "termsofservicepage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<TermsOfServicePage />} />
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<TermsOfServicePage />} />
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
